var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"player",attrs:{"id":"bgndVideo","data-property":"{videoURL:'https://youtu.be/SqrRkSgTsnU',containment:'body',autoPlay:true, mute:true, startAt:0, opacity:1}"}})
}
var staticRenderFns = []

export { render, staticRenderFns }